import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import {
  addBatchLoanSancOnly,
  deleteBatchLoanSancOnly,
} from "../../../actions/shg";

export const BatchLoanSanction = ({
  NextBackBtn,
  allMembers,
  activeBank,
  allpurpose,
  formData,
  setFormData,
  getLoanSantionedData,
  meetingBatchInfo,
  addBatchLoanSancOnly,
  deleteBatchLoanSancOnly,
  isThisFirstMeeting,
  shg: { loanSactionedData },
}) => {
  const [loanSanMemberObject, setLoanSanMemberObject] = useState({
    memberData: null,
    loanSanctionedAmt: "",
    loanReasonId: null,
    loanPurpose: null,
    otherPurpose: null,
    nominee: "",
  });

  const transactionType = [
    { label: "Bank", value: "Bank" },
    { label: "Cash", value: "Cash" },
  ];
  const [type, setType] = useState("");
  const [isBank, setIsBank] = useState(false);
  const [selectedBank, setSelectedBank] = useState("");

  const inputBankDetChange = (e) => {
    setSelectedBank(e);
  };

  const onTransactionChange = (e) => {
    setType(e);
    if (e.label === "Bank") {
      setIsBank(true);
    } else {
      setIsBank(false);
    }
  };

  useEffect(() => {
    getLoanSantionedData(meetingBatchInfo);
  }, []);

  let {
    memberData,
    loanSanctionedAmt,
    loanReasonId,
    loanPurpose,
    otherPurpose,
    nominee,
  } = loanSanMemberObject;

  const onInputChange = (e, label = "") => {
    if (label == "") {
      setLoanSanMemberObject({
        ...loanSanMemberObject,
        [e.target.name]: e.target.value,
      });
    } else {
      setLoanSanMemberObject({ ...loanSanMemberObject, [label]: e });
    }
  };

  const funcKeyDown = (e) => {
    ["e", "E", "+", "-"].includes(e.key) && e.preventDefault();
  };

  // let bankLoanArray = [];
  // const [bankLoanArray, setBankLoanArray] = useState([]);
  // const [cashLoanArray, setCashLoanArray] = useState([]);
  const [bankNotSelectedError, setBankNotSelectedError] = useState(false);

  const AddSanctionIntLoan = async () => {
    if (isBank && selectedBank == "") {
      setBankNotSelectedError(true);
    } else {
      setBankNotSelectedError(false);
      let newIntLoanData = {
        batchId: formData.batchId,
        memberId: memberData.memberIds,
        memberName: memberData.label,
        batchMeetingMonth: formData.batchMeetingMonth,
        batchMeetingYear: formData.batchMeetingYear,
        meetingHeldOnDate: formData.batchMeetingHeldOnDate,

        loanSanctionedAmt: loanSanctionedAmt,
        loanReasonId: loanPurpose.loanReasonId,
        loanPurpose: loanPurpose.label,
        otherPurpose: null,
        nominee: nominee,

        loanSanctionedEnteredById: null,
        loanSanctionedEnteredByName: null,
        loanSanctionedEnteredDateTime: null,

        institutionId: formData.institutionId,
        loanSanctionedStatus: "Active",
        isLoanType: "Internal",
        loanStatus: "Active",
        intLoanType: "BATCH LOAN",
        TransactionType: {
          BankName: isBank ? selectedBank.label : "",
          BankId: isBank ? selectedBank.bankId : "",
          TransactionMode: isBank ? "Bank" : "Cash",
        },
      };
      // console.log("newIntLoanData", newIntLoanData);
      await addBatchLoanSancOnly(newIntLoanData);
      setFormData({
        ...formData,
      });

      getLoanSantionedData(meetingBatchInfo);

      setLoanSanMemberObject({
        memberData: null,
        loanSanctionedAmt: "",
        loanReasonId: null,
        loanPurpose: null,
        otherPurpose: null,
        nominee: "",
      });
      setType("");
      setIsBank("");
      setSelectedBank("");
    }
  };

  const [showWarningModal, setShowWarningModal] = useState(false);
  const [deletionData, setDeletionData] = useState("");
  const onDeleteIntLoan = (loanData) => {
    setDeletionData(loanData);
    setShowWarningModal(true);
  };
  const DeleteLoan = async () => {
    setShowWarningModal(true);
    await deleteBatchLoanSancOnly(deletionData);
    getLoanSantionedData(meetingBatchInfo);
  };

  //////////////////////////////////////////////////////////////////////new code start//////////////////////////////////////

  const updatedLoanData = loanSactionedData.map((loan) => {
    // Check if TransactionType exists, if not, set it as "Cash"
    if (!loan.TransactionType) {
      return {
        ...loan,
        TransactionType: {
          batchBankName: "",
          batchBankNameId: "",
          TransactionMode: "Cash", // Set default mode to Cash if TransactionType is missing
        },
      };
    }
    return loan; // If TransactionType exists, just return the loan as is
  });

  useEffect(() => {
    let bankLoanArray = []; // Always start with an empty array
    let cashLoanArray = []; // Always start with an empty array

    updatedLoanData.forEach((loan) => {
      if (loan.isLoanType === "Internal") {
        if (loan.TransactionType.TransactionMode === "Bank") {
          const existingBankLoanIndex = bankLoanArray.findIndex(
            (loanItem) =>
              loanItem.batchBankNameId === loan.TransactionType.BankId,
          );

          if (existingBankLoanIndex !== -1) {
            bankLoanArray[existingBankLoanIndex].indBatchBankWithdrawals +=
              Number(loan.loanSanctionedAmt);
          } else {
            bankLoanArray.push({
              batchBankNameId: loan.TransactionType.BankId,
              indBatchBankWithdrawals: Number(loan.loanSanctionedAmt),
              transactionType: "B-IL",
              batchBankName: loan.TransactionType.BankName,
              indBankInterest: 0,
              indBankCommission: 0,
              indBatchBankDeposit: 0,
            });
          }
        } else if (loan.TransactionType.TransactionMode === "Cash") {
          const existingCashLoanIndex = cashLoanArray.findIndex(
            (loanItem) => loanItem.transactionType === "Cash",
          );

          if (existingCashLoanIndex !== -1) {
            cashLoanArray[existingCashLoanIndex].indBatchBankWithdrawals +=
              Number(loan.loanSanctionedAmt);
          } else {
            cashLoanArray.push({
              indBatchBankWithdrawals: Number(loan.loanSanctionedAmt),
              transactionType: "Cash",
            });
          }
        }
      }
    });

    const batchLoanAmt = {
      cash: cashLoanArray.reduce(
        (acu, cur) => acu + Number(cur.indBatchBankWithdrawals),
        0,
      ),
      bankAmt: bankLoanArray.reduce(
        (acu, cur) => acu + Number(cur.indBatchBankWithdrawals),
        0,
      ),
      bankName: bankLoanArray.length > 0 ? bankLoanArray[0].BankName : "",
    };

    setFormData({
      ...formData,
      loanSactionedData: updatedLoanData,
      batchLoanAmt: batchLoanAmt,
      bankLoanArray: bankLoanArray,
      cashLoanArray: cashLoanArray,
    });
  }, [loanSactionedData]);

  const [setLessBalanceError, setSetLessBalanceError] = useState("");
  const OnNextIntLoanTab = () => {
    let totalIncomeAndExpense = Number(formData.totalIncomeAndExpense || 0);
    let batchLoanAmt = loanSactionedData
      .filter((ele) => ele.isLoanType == "Internal")
      .reduce((acu, cur) => (acu += Number(cur.loanSanctionedAmt)), 0);

    if (isThisFirstMeeting) {
      setSetLessBalanceError("");

      setFormData({
        ...formData,
        loanSactionedData: loanSactionedData,
        batchLoanAmt: {
          cash: loanSactionedData
            .filter((ele) => ele.isLoanType == "Internal")
            .reduce((acu, cur) => (acu += Number(cur.loanSanctionedAmt)), 0),
          bankAmt: 0,
          bankName: "",
        },
      });
      NextBackBtn(7);
    } else {
      if (totalIncomeAndExpense < batchLoanAmt) {
        setSetLessBalanceError("Sanctioned Amount is higher than Balance");
      } else {
        setSetLessBalanceError("");

        setFormData({
          ...formData,
          loanSactionedData: loanSactionedData,
          batchLoanAmt: {
            cash: loanSactionedData
              .filter((ele) => ele.isLoanType == "Internal")
              .reduce((acu, cur) => (acu += Number(cur.loanSanctionedAmt)), 0),
            bankAmt: 0,
            bankName: "",
          },
        });
        NextBackBtn(7);
      }
    }
  };

  return (
    <>
      <div className="row card-new  py-3 col-12">
        <div className="col-lg-12 col-md-12 col-sm-12 col-12">
          <h5>Loan Details</h5>
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 col-12 cardUpdate">
          <div className="row">
            <div className="col-lg-6 col-md-6 col-sm-6">
              <label className="label-control">Transaction Type* :</label>
              <Select
                name="TransactionType"
                options={transactionType}
                isSearchable={true}
                value={type}
                placeholder="Type"
                onChange={(e) => onTransactionChange(e)}
                required
                theme={(theme) => ({
                  ...theme,
                  height: 26,
                  minHeight: 26,
                  borderRadius: 1,
                  colors: {
                    ...theme.colors,
                    primary: "black",
                  },
                })}
              />
            </div>
            <div className="col-lg-6 col-md-6 col-sm-6">
              {isBank ? (
                <>
                  <label
                    className="label-control"
                    style={
                      bankNotSelectedError
                        ? { color: "red" }
                        : { color: "black" }
                    }
                  >
                    Select Bank* :
                  </label>
                  <Select
                    name="selBanks"
                    options={activeBank}
                    isSearchable={true}
                    placeholder="Select Bank"
                    onChange={(e) => inputBankDetChange(e)}
                    value={selectedBank}
                  />
                </>
              ) : (
                <></>
              )}
            </div>
          </div>

          <label className="label-control">Loan Sanctioned-Member* :</label>
          <div className=" col-12 col-lg-12 col-md-12 col-sm-12">
            <Select
              name="memberData"
              options={allMembers}
              isSearchable={true}
              value={memberData}
              placeholder="Select member"
              onChange={(e) => onInputChange(e, "memberData")}
              theme={(theme) => ({
                ...theme,
                height: 26,
                minHeight: 26,
                borderRadius: 1,
                colors: {
                  ...theme.colors,
                  primary: "black",
                },
              })}
              required
            />
          </div>

          <label className="label-control">Loan Sanctioned Purpose* :</label>
          <div className="col-12 col-lg-12 col-md-12 col-sm-12">
            <Select
              name="loanPurpose"
              options={allpurpose}
              isSearchable={true}
              value={loanPurpose}
              placeholder="Select Purpose"
              onChange={(e) => onInputChange(e, "loanPurpose")}
              theme={(theme) => ({
                ...theme,
                height: 26,
                minHeight: 26,
                borderRadius: 1,
                colors: {
                  ...theme.colors,
                  primary: "black",
                },
              })}
            />
          </div>
        </div>

        <div className="col-lg-6 col-md-12 col-sm-12 col-12 cardUpdate">
          <label className="label-control">
            IL Sanctioned Amount*&nbsp;
            <img
              className="img_icon_size log"
              src={require("../../../static/images/info.png")}
              alt="Reason"
              style={{ height: "18px", width: "18px" }}
              title="	Internal Loan Sanctioned to Member"
            />
            &nbsp;:
          </label>
          <div className="row col-12">
            <div className="col-lg-12 col-md-12 col-sm-12">
              <input
                type="number"
                name="loanSanctionedAmt"
                value={loanSanctionedAmt}
                className="form-control"
                onChange={(e) => onInputChange(e)}
                onWheel={() => document.activeElement.blur()}
                onKeyDown={(e) => funcKeyDown(e)}
                required
              />
            </div>
            <label className="label-control">Nominee :</label>
            <div className="row col-12">
              <input
                type="text"
                name="nominee"
                value={nominee}
                className="form-control"
                onWheel={() => document.activeElement.blur()}
                onChange={(e) => onInputChange(e)}
              />
            </div>
          </div>

          <div>
            <button
              className="btn sub_form btn_continue Save float-right"
              type="button"
              disabled={!memberData || !loanPurpose ? true : false}
              onClick={() => AddSanctionIntLoan()}
            >
              Add
            </button>
          </div>
        </div>
      </div>

      <div className=" body-inner no-padding  table-responsive">
        <table
          className="tabllll table table-bordered table-striped table-hover"
          id="datatable2"
        >
          <thead>
            <tr>
              <th>Loan Sanctioned Member</th>
              <th>Loan Sanctioned Amount</th>
              <th>Nominee</th>
              <th>Loan Sanctioned Purpose</th>
              <th>OP</th>
            </tr>
          </thead>
          <tbody>
            {loanSactionedData.map((LoanData, idx) => {
              if (LoanData.isLoanType == "Internal")
                return (
                  <tr key={idx}>
                    <td>{LoanData.memberName}</td>
                    <td>{LoanData.loanSanctionedAmt}</td>
                    <td>{LoanData.nominee}</td>
                    <td>{LoanData.loanPurpose}</td>
                    <td>
                      <img
                        className="img_icon_size log"
                        onClick={() => onDeleteIntLoan(LoanData)}
                        src={require("../../../static/images/delete.png")}
                        alt="Deactivate"
                        title="Deactivate"
                      />
                    </td>
                  </tr>
                );
            })}
          </tbody>
        </table>
      </div>

      <div className="col-lg-12 col-md-12 col-sm-12 col-12">
        <span className="col-lg-12 text-right" style={{ color: "red" }}>
          {setLessBalanceError}
        </span>
        <button
          className="btn sub_form btn_continue Save float-right"
          onClick={
            () => OnNextIntLoanTab()
            // NextBackBtn(6)
          }
        >
          Next
        </button>
        <button
          className="btn sub_form btn_continue Save float-right"
          onClick={() => NextBackBtn(5)}
        >
          Previous
        </button>
      </div>

      <Modal
        show={showWarningModal}
        backdrop="static"
        keyboard={false}
        size="md"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Header>
          <div className="col-lg-11 ">
            <h3 className="modal-title ">Attention</h3>
          </div>
          <div className="col-lg-1 mr-3">
            <button
              onClick={() => setShowWarningModal(false)}
              className="close"
            >
              <img
                src={require("../../../static/images/close.png")}
                alt="X"
                style={{ height: "20px", width: "20px" }}
              />
            </button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <div className="text-center">
            <h5>Are you sure you want to delete the loan sanction details?</h5>
            <span>
              {" "}
              Note: If applicable, please ensure that any consecutive repayments
              related to this loan in the upcoming batch meetings are deleted as
              well.
            </span>
          </div>
          <div className="col-md-12 col-lg-11 col-sm-12 col-12 text-left">
            <input
              type="button"
              onClick={() => {
                DeleteLoan();
              }}
              name="submit"
              value="Delete"
              className="btn sub_form btn_continue Save float-right"
              // disabled={editDisabled}
            />
            <input
              type="button"
              name="Prtev"
              value="Cancel"
              onClick={() => setShowWarningModal(false)}
              className="btn sub_form btn_continue Save float-right"
            />
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

BatchLoanSanction.propTypes = {
  auth: PropTypes.object.isRequired,
  shg: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  shg: state.shg,
});

const mapDispatchToProps = {
  addBatchLoanSancOnly,
  deleteBatchLoanSancOnly,
};

export default connect(mapStateToProps, mapDispatchToProps)(BatchLoanSanction);
